import flow from 'lodash/fp/flow';
import getOr from 'lodash/fp/getOr';

export const pluralizeForKey = (key, str) =>
  flow(
    getOr(0, key),
    total => (total === 1 ? str : `${str}s`),
  );
